import React from 'react';
import * as rssParser from 'react-native-rss-parser';
import Moment from 'react-moment';

// Import local RSS feed XML files
import feedYLEEnglish from '../data/rssfeeds/YLE-English.xml';
import feedBBCWorld from '../data/rssfeeds/BBC-World.xml';
import feedNYTWorld from '../data/rssfeeds/NYT-World.xml';
import feedTOIWorld from '../data/rssfeeds/TOI-World.xml';
import feedHTWorld from '../data/rssfeeds/HT-World.xml';
import feedTheHinduWorld from '../data/rssfeeds/The-Hindu-World.xml';
import feedTOITop from '../data/rssfeeds/TOI-Top.xml';
import feedHTLatest from '../data/rssfeeds/HT-Latest.xml';
import feedTheHinduTopNews from '../data/rssfeeds/The-Hindu-Top-News.xml';
import feedBBCTop from '../data/rssfeeds/BBC-Top.xml';
import feedNYTTop from '../data/rssfeeds/NYT-Top.xml';
import feedNYTAsiaPacific from '../data/rssfeeds/NYT-Asia-Pacific.xml';
import feedBBCHealth from '../data/rssfeeds/BBC-Health.xml';
import feedBBCScience from '../data/rssfeeds/BBC-Science.xml';
import feedNYTHealth from '../data/rssfeeds/NYT-Health.xml';
import feedNYTScience from '../data/rssfeeds/NYT-Science.xml';


/* ==================================================== */
class MyAppSingleFeed1 extends React.Component {
  constructor() {
    super();
    this.state = {
      showProgressBar: true,
      feedTitle: '',
      feedLength: '',
      lastBuildDate: new Date(),
      feedItems: [],
    }
  }

  getFeedContent() {
    // Use local file path instead of external URL
    const feedPath = this.props.feedPath;
    console.log('CURRENT_FEED = ' + feedPath);
    return fetch(feedPath);
  };

  componentDidMount() {
    this.getFeedContent()
      .then((response) => response.text())
      .then((responseData) => rssParser.parse(responseData))
      .then((rss) => {
        //console.log(rss.title);
        //console.log(rss.lastUpdated);
        //console.log(rss.items.length);
        //console.log(rss.items);
        //console.log(rss.items[0].title);
        //console.log(rss.items[0].id);
        //console.log(rss.items[0].published);
        // setting state for all variables
        this.setState({ feedItems: rss.items });
        this.setState({ feedLength: rss.items.length });
        this.setState({ feedTitle: rss.title });
        this.setState({ lastBuildDate: rss.lastUpdated });
        this.setState({ showProgressBar: false });
      });
    return null;
  }

  printProgressBar() {
    if (this.state.showProgressBar) {
      return <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    }
  };

  printObjectElements(myitems1 = this.state.feedItems) {
    let rows = [];
    let count = 0;
    for (let x in myitems1) {
      count++;
      if (count < 11) {
        //console.log(myitems1[x].id) ;
        //console.log(myitems1[x].links[0].url) ;
        const articleUrl = myitems1[x].links[0].url;
        const articleTitle = myitems1[x].title;
        rows.push(<li className='pb-2' key={articleUrl}><a target='_blank' rel='noopener noreferrer' href={articleUrl}>{articleTitle}</a> (<Moment fromNow>{myitems1[x].published}</Moment>)</li>);
      }
    }
    return <ul>{rows}</ul>;
  };

  render() {
    const feedTitle = this.state.feedTitle;
    const feedLength = this.state.feedLength;
    const lastBuildDate = this.state.lastBuildDate;
    const myitems = this.state.feedItems;
    const printFullItemList = this.printObjectElements(myitems);
    const printProgressBar = this.printProgressBar();

    return (
      <div className="col-sm-12 col-xs-12 col-md-6 col-lg-4 col-xl-4">
        <div className="card text-dark bg-light mb-3">
          <div className="card-header">Feed last updated: <strong><Moment fromNow>{lastBuildDate}</Moment></strong><br />(Feed contains {feedLength} posts)</div>
          <div className="card-body">
            <h5 className="card-title">{feedTitle}</h5>
            <div className="card-text">{printFullItemList}</div>
            {printProgressBar}
          </div>
        </div>
      </div>
    );
  }
}
/* ==================================================== */

const MyNewsFeeds = () => {
  return (
    <div className="row">
      <div className="col-12"><h1 className="display-5">Latest News</h1></div>
      <MyAppSingleFeed1 feedPath={feedYLEEnglish} />
      <MyAppSingleFeed1 feedPath={feedBBCWorld} />
      <MyAppSingleFeed1 feedPath={feedNYTWorld} />
      <MyAppSingleFeed1 feedPath={feedTOIWorld} />
      <MyAppSingleFeed1 feedPath={feedHTWorld} />
      <MyAppSingleFeed1 feedPath={feedTheHinduWorld} />

      <MyAppSingleFeed1 feedPath={feedTOITop} />
      <MyAppSingleFeed1 feedPath={feedHTLatest} />
      <MyAppSingleFeed1 feedPath={feedTheHinduTopNews} />

      <MyAppSingleFeed1 feedPath={feedBBCTop} />
      <MyAppSingleFeed1 feedPath={feedNYTTop} />
      <MyAppSingleFeed1 feedPath={feedNYTAsiaPacific} />

      <MyAppSingleFeed1 feedPath={feedBBCHealth} />
      <MyAppSingleFeed1 feedPath={feedBBCScience} />
      <MyAppSingleFeed1 feedPath={feedNYTHealth} />
      <MyAppSingleFeed1 feedPath={feedNYTScience} />
    </div>
  )
}

/* ==================================================== */

export default MyNewsFeeds

